import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/styles/main.less";

// 插件
// import "./plugins/element-ui";
import "./assets/style/common/index.less";


Vue.config.productionTip = false;
if (process.env.NODE_ENV !== "production") {
  const eruda = require("eruda")
  eruda.init()
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
